module.exports = require("@material-ui/icons/Phone");